import { useBreakpoint } from '@hh.ru/magritte-ui';

import { UserType } from 'src/models/userType';

import { useExperiment } from 'src/hooks/useExperiment';
import { useSelector } from 'src/hooks/useSelector';

export const useRedesignAnonymousMenuExpActive = () => {
    const userType = useSelector(({ userType }) => userType);
    const { isXS } = useBreakpoint();
    const isRedesignAnonymousMenuExpB = useExperiment('redesign_anonymous_menu_v3_b', true, false);
    const isRedesignAnonymousMenuExpC = useExperiment('redesign_anonymous_menu_v3_c', true, false);

    return userType === UserType.Anonymous && ((isRedesignAnonymousMenuExpB && !isXS) || isRedesignAnonymousMenuExpC);
};
